import { useEffect } from 'react';

import { broadcastResponseToMainFrame } from '@azure/msal-browser/redirect-bridge';

import { GeneralLoaderWrapper } from '~layouts';

/**
 * Dedicated page for entry silent renew callback. This happens when the session needs
 * to be extended on Entra, rather that a session refresh within the application.
 */
const SilentCallbackPage = () => {
	useEffect(() => {
		// Call broadcastResponseToMainFrame when component mounts
		broadcastResponseToMainFrame().catch((error) => {
			console.error('Error broadcasting response to main frame:', error);
		});
	}, []);

	// Should automatically navigate to the page is was redirected from.
	return <GeneralLoaderWrapper />;
};

export default SilentCallbackPage;
